import React, { useEffect, useState } from "react";

/**
 * Loads What.html (the section content only, not header/footer)
 * and injects it into the DOM using dangerouslySetInnerHTML.
 */
const WhatDo: React.FC = () => {
  const [WhatHtml, setWhatHtml] = useState("");

  useEffect(() => {
    fetch("/What.html")
      .then((res) => res.text())
      .then((data) => setWhatHtml(data))
      .catch((err) => console.error("Error loading What.html", err));
  }, []);

  return (
    <section
      id="What"
      dangerouslySetInnerHTML={{ __html: WhatHtml }}
    />
  );
};

export default WhatDo;